module.exports = __webpack_public_path__ + "img/score.1eb0de5d.png";